module.exports = __webpack_public_path__ + "img/dc-pressure.205aab2c.svg";